import { useContext } from "react";
import { LoginContext } from "./LoginContext";
import LoadingPage from "../pages/LoadingPage";

const ProtectedComponent = ({ children, module, action }) => {
  const { hasPermission } = useContext(LoginContext);
  const permissionResult = hasPermission(module, action);

  if (permissionResult === null) {
    // Still loading
    return <LoadingPage />;
  }

  if (!permissionResult) {
    return <LoadingPage />;
  }

  return children;
};


export default ProtectedComponent;